/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Dd_Charter_LabelInputs */

const es_nav_dd_charter_label = /** @type {(inputs: Nav_Dd_Charter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter Lista 6ª`)
};

const gl_nav_dd_charter_label = /** @type {(inputs: Nav_Dd_Charter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter Lista 6ª`)
};

const en_nav_dd_charter_label = /** @type {(inputs: Nav_Dd_Charter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List 6 charter`)
};

/**
* | output |
* | --- |
* | "List 6 charter" |
*
* @param {Nav_Dd_Charter_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_dd_charter_label = /** @type {((inputs?: Nav_Dd_Charter_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Dd_Charter_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_dd_charter_label(inputs)
	if (locale === "en") return en_nav_dd_charter_label(inputs)
	return es_nav_dd_charter_label(inputs)
});